const defaultFormat = /(\d{1,4})/g;

export class CreditCard {

  public static restrictNumeric(e: KeyboardEvent): boolean {
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    const input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  public static hasTextSelected(target: HTMLInputElement) {
    return target.selectionStart !== null && target.selectionStart !== target.selectionEnd;
  }

  public static safeVal(value: string, target: HTMLInputElement, updateValue: (value: string) => void): number {
    let cursor: number | null = null;
    const last = target.value;
    let result: number = null;

    try {
      cursor = target.selectionStart;
    } catch (error) {}

    updateValue(value);

    if (cursor !== null && target === document.activeElement) {
      if (cursor === last.length) {
        cursor = value.length;
      }

      if (last !== value) {
        const prevPair = last.slice(cursor - 1, +cursor + 1 || 9e9);
        const currPair = value.slice(cursor - 1, +cursor + 1 || 9e9);
        const digit = value[cursor];

        if (/\d/.test(digit) && prevPair === (`${digit} `) && currPair === (` ${digit}`)) {
          cursor = cursor + 1;
        }
      }

      result = cursor;
    }
    return result;
  }

  public static restrictExpiry(key: number, target: HTMLInputElement) {
    const digit = String.fromCharCode(key);
    if (!/^\d+$/.test(digit) || this.hasTextSelected(target)) {
      return false;
    }
    const value = `${target.value}${digit}`.replace(/\D/g, '');

    return value.length > 6;
  }

  public static replaceFullWidthChars(str: string) {
    if (str === null) {
      str = '';
    }

    const fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
    const halfWidth = '0123456789';
    let value = '';
    const chars = str.split('');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < chars.length; i++) {
      let chr = chars[i];
      const idx = fullWidth.indexOf(chr);
      if (idx > -1) {
        chr = halfWidth[idx];
      }
      value += chr;
    }
    return value;
  }

  public static formatExpiry(expiry: string) {
    const parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,2})?/);

    if (!parts) {
      return '';
    }

    let mon  = parts[1] || '';
    let sep  = parts[2] || '';
    const year = parts[3] || '';

    if (year.length > 0) {
      sep = ' / ';
    } else if (sep === ' /') {
      mon = mon.substring(0, 1);
      sep = '';
    } else if (mon.length === 2 || sep.length > 0) {
      sep = ' / ';
    } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
      mon = `0${mon}`;
      sep = ' / ';
    }
    return `${mon}${sep}${year}`;
  }

}

const lookup = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]

export const luhnCheck = (number: string) => {
  number = number?.replaceAll(' ', '');
  if (typeof number !== 'string') throw new TypeError('Expected string input')
  if (!number) return false
  let index = number.length
  let x2 = true
  let sum = 0
  while (index) {
    const value = number.charCodeAt(--index) - 48
    if (value < 0 || value > 9) return false
    x2 = !x2
    sum += x2 ? lookup[value] : value
  }
  return sum % 10 === 0
}
